<div class="resultat">
  <label>Risc detectat</label>
  <div class="ambBorde" [ngStyle]="{'border-color':resultat.gravetatRisc.colorSemafor}">
    {{resultat.gravetatRisc.textValGlobalSimulacio}}
  </div>
  <label>Tipus de maltractament detectat</label>
  <div>
    <div *ngIf="!resultat.tipusMalPrin || resultat.tipusMalPrin.length == 0">
      {{resultat.gravetatRisc.textNoTipusMalSimulacio}}
    </div>
    <div *ngIf="resultat.tipusMalPrin && resultat.tipusMalPrin.length > 0">
      {{resultat.gravetatRisc.textTipMalSimulacio}} <ng-container *ngFor="let tipus of resultat.tipusMalPrin; index as i"><ng-container *ngIf="i>0"> i/o </ng-container>{{tipus.descripcio}}</ng-container>
    </div>
    <div *ngIf="resultat.tipusMalSec && resultat.tipusMalSec.length > 0">
      {{resultat.gravetatRisc.textTipMalSecSimulacio}} <ng-container *ngFor="let tipus of resultat.tipusMalSec; index as i"><ng-container *ngIf="i>0"> i/o </ng-container>{{tipus.descripcio}}</ng-container>
    </div>
  </div>
  <label>Risc de repetició</label>
  <div *ngIf="!resultat.riscNousEpisodis || resultat.riscNousEpisodis.length == 0">
    {{resultat.gravetatRisc.textNoRiscEpisodisSimulacio}}
  </div>
  <div *ngIf="resultat.riscNousEpisodis && resultat.riscNousEpisodis.length > 0">
    {{resultat.gravetatRisc.textRiscEpisodisSimulacio}}
    <ul>
      <li *ngFor="let riscNouEpisodi of resultat.riscNousEpisodis">{{riscNouEpisodi.textAuxiliar}}</li>
    </ul>
  </div>
</div>

<div class="button-bar">
  <button class="main" (click)="goToPrevStep()"><i class="fas fa-angle-left prev" aria-hidden></i> {{'globals.anterior'
    | translate}}</button>
  <button class="main" (click)="goToNextStep()" [disabled]="resultat.gravetatRisc.colorSemafor == 'white'">{{'globals.seguent' | translate}} <i class="fas fa-angle-right next"
      aria-hidden></i></button>
</div>